// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"9b1d8fe6","416":"9e17b7b4","580":"a4e295b9","597":"df01a181","655":"effaf258","777":"baea578b","842":"a7c5fdc4"}[chunkId] + ".chunk.css";
};